import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=6f3f9b80&scoped=true"
import script from "./PriceInfo.vue?vue&type=script&lang=js"
export * from "./PriceInfo.vue?vue&type=script&lang=js"
import style0 from "./PriceInfo.vue?vue&type=style&index=0&id=6f3f9b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f9b80",
  null
  
)

export default component.exports